import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import styles from './FiltersModalForCustomers.module.scss';
import close from "../../constants/images/close.svg";
import MainButtonTransparentBackground from "../UI/MainButtonTransparentBackground/MainButtonTransparentBackground";
import MainButtonWithBackground from "../UI/MainButtonWithBackground/MainButtonWithBackground";
import CustomCheckbox from "../UI/CustomCheckbox/CustomCheckbox";
import {filtersForCustomerActions} from "../../store/slices/filtersForCustomerSlice";
import {cleanerApplicationsActions} from "../../store/slices/cleanerApplicationsSlice";

const FiltersModalForCustomers = ({handleClose, page, setPage}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const {pathname} = useLocation();
    const array = pathname.split('/');
    const id = array[array.length - 1];

    const dispatch = useDispatch();
    const {min_price, max_price, ordering} = useSelector(state => state.filtersForCustomer);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getFilteredCleanerApplications = async () => {
        try {
            const params = {min_price, max_price, ordering};

            await dispatch(cleanerApplicationsActions.getFilteredByCleanerRequest({id, params}));
        } catch (error) {
            console.error(error);
        }
    }

    const handleChangeMinPrice = (event) => {
        const minPrice = +event.target.value;

        if (minPrice > 0) {
            dispatch(filtersForCustomerActions.setMinPrice(minPrice));
        } else {
            dispatch(filtersForCustomerActions.setMinPrice(null));
        }
    }

    const handleChangeMaxPrice = (event) => {
        const maxPrice = event.target.value;

        if (maxPrice > 0) {
            dispatch(filtersForCustomerActions.setMaxPrice(maxPrice));
        } else {
            dispatch(filtersForCustomerActions.setMaxPrice(null));
        }
    }

    const handleApplyFilters = () => {
        getFilteredCleanerApplications();

        handleClose(); // close modal
    }

    return (
        <div className={styles.filtersModalForCustomers}>
            <div className={styles.filtersModalForCustomers_content}>
                <div className={styles.filtersModalForCustomers_content_title}>
                    <h2>Фільтри</h2>
                    <img
                        onClick={handleClose}
                        style={{cursor: "pointer"}}
                        src={close}
                        alt="close icon"
                    />
                </div>

                <div className={styles.filtersModalForCustomers_content_diviver}></div>
                <div className={styles.filtersModalForCustomers_content_price}>
                    <p className={styles.subtitle}>Вартість клінінгу</p>
                    <div className={styles.filtersModalForCustomers_content_price_container}>
                        <label className={styles.label}>
                            Від
                            <input
                                className={styles.input}
                                type="number"
                                value={min_price}
                                onChange={handleChangeMinPrice}
                                min={0}
                            />
                        </label>
                        <div className={styles.minus}></div>
                        <label className={styles.label}>
                            До
                            <input
                                className={styles.input}
                                type="number"
                                defaultValue={max_price}
                                onChange={handleChangeMaxPrice}
                                min={0}
                            />
                        </label>
                    </div>
                </div>

                <div className={styles.filtersModalForCustomers_content_diviver}></div>
                <div className={styles.filtersModalForCustomers_content_cleanerType}>
                    <p className={styles.subtitle}>Тип клінера</p>
                    <div className={styles.filtersModalForCustomers_content_cleanerType_checkboxes}>
                        <CustomCheckbox handleCheckboxChange={null} isChecked={null} text={'Топ - клінер'} id={6}/>
                        <CustomCheckbox handleCheckboxChange={null} isChecked={null} text={'Клінер'} id={7}/>
                    </div>
                </div>
                <div className={styles.filtersModalForCustomers_content_buttons}>
                    <MainButtonTransparentBackground
                        onClick={handleClose}
                        text={'Скасувати'}
                        type={'button'} // button, submit, reset
                        width={windowWidth > 768 ? 'auto' : '100%'}
                        condition={false} // is button disabled
                    />

                    <MainButtonWithBackground
                        onClick={handleApplyFilters}
                        text={windowWidth > 768 ? 'Застосувати Фільтри' : 'Застосувати'}
                        type={'button'} // button, submit, reset
                        width={windowWidth > 768 ? 'auto' : '100%'}
                        condition={false} // is button disabled
                    />
                </div>
            </div>
        </div>
    );
};

export default FiltersModalForCustomers;
